"use client";

import React, { useState, useEffect } from "react";
import { GoogleMap, LoadScript, MarkerF } from "@react-google-maps/api";
import "./Map.scss";
import { useMediaQuery } from "@mui/material";

const mapOptions = {
  zoomControl: true,
  clickableIcons: true,
  styles: [
    {
      elementType: "geometry",
      stylers: [{ color: "#023e58" }],
    },
    {
      elementType: "labels.icon",
      stylers: [{ visibility: "off" }],
    },
    {
      elementType: "labels.text.fill",
      stylers: [{ color: "#97a5be" }],
    },
    {
      elementType: "labels.text.stroke",
      stylers: [{ color: "#97a5be" }],
    },
    {
      featureType: "administrative",
      elementType: "geometry",
      stylers: [{ color: "#97a5be" }],
    },
    {
      featureType: "administrative.country",
      elementType: "labels.text.fill",
      stylers: [{ color: "#8ec3b9" }],
    },
    {
      featureType: "administrative.land_parcel",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "administrative.locality",
      elementType: "labels.text.fill",
      stylers: [{ color: "#bdbdbd" }],
    },
    {
      featureType: "poi",
      elementType: "labels.text.fill",
      stylers: [{ color: "#8ec3b9" }],
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [{ color: "#181818" }],
    },
    {
      featureType: "poi.park",
      elementType: "labels.text.fill",
      stylers: [{ color: "#616161" }],
    },
    {
      featureType: "poi.park",
      elementType: "labels.text.stroke",
      stylers: [{ color: "#1b1b1b" }],
    },
    {
      featureType: "road",
      elementType: "geometry.fill",
      stylers: [{ color: "#314a7d" }],
    },
    {
      featureType: "road",
      elementType: "labels.text.fill",
      stylers: [{ color: "314a7d" }],
    },
    {
      featureType: "road.arterial",
      elementType: "geometry",
      stylers: [{ color: "#314a7d" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry",
      stylers: [{ color: "#314a7d" }],
    },
    {
      featureType: "road.highway.controlled_access",
      elementType: "geometry",
      stylers: [{ color: "#314a7d" }],
    },
    {
      featureType: "road.local",
      elementType: "labels.text.fill",
      stylers: [{ color: "#314a7d" }],
    },
    {
      featureType: "transit",
      elementType: "labels.text.fill",
      stylers: [{ color: "#8ec3b9" }],
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [{ color: "#000000" }],
    },
    {
      featureType: "water",
      elementType: "labels.text.fill",
      stylers: [{ color: "#8ec3b9" }],
    },
  ],
  draggable: true,
  scrollwheel: true,
};

const Map = ({ apiKey }) => {
  const isMobile = useMediaQuery("(max-width:1023px)");
  const [isLoaded, setIsLoaded] = useState(false);
  const [mapCenter, setMapCenter] = useState({
    lat: 42.1096812,
    lng: -83.0686108,
  });

  useEffect(() => {
    if (window.google && window.google.maps) {
      setIsLoaded(true);
    }

    return () => {
      setIsLoaded(false);
    };
  }, []);

  return (
    <LoadScript googleMapsApiKey={apiKey} onLoad={() => setIsLoaded(true)}>
      <GoogleMap
        mapContainerClassName="map-container"
        center={mapCenter}
        zoom={isMobile ? 13 : 14}
        options={mapOptions}
      >
        {isLoaded && (
          <div className="marker-wrapper">
            <MarkerF
              position={mapCenter}
              options={{
                icon: {
                  url: "/assets/map_marker.svg",
                },
                animation: window.google.maps.Animation.DROP,
              }}
            />
          </div>
        )}
      </GoogleMap>
    </LoadScript>
  );
};

export default Map;
